import { SIZES } from '_constants';

export default {
  SIZE: {
    M: SIZES.MEDIUM,
    S: SIZES.SMALL,
  },
};
